import { typedAction } from './common/actions';
import { getConfig as getUrlConfig, IConfig } from '../../../url-reader';
import { RootState } from '../redux/reducers';
import { Nullable } from '../../../shared/types/Typescript-utils';

interface ConfigState {
  config: Nullable<IConfig>;
}
const initialState: ConfigState = {
  config: null,
};

export const GET = 'config/get';

export const getConfig = () => {
  const config = getUrlConfig();
  return typedAction(GET, config);
};

type ConfigAction = ReturnType<typeof getConfig>;
export function configReducer(state = initialState, action: ConfigAction): ConfigState {
  switch (action.type) {
    case GET:
      return { ...state, config: action.payload };
    default:
      return state;
  }
}

export const selectConfig = (state: RootState) => state.config;
